
















































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";

@Component({
    components: {
        DateComponent: () => import("@/components/common/Inputs/Date.vue")
    }
})
export default class StoryForm extends Vue {
    @Prop() steps!: any;
    @Prop() model!: any;
    @Prop({ default: false })readOnly!: boolean;

    stepSelected() {
        this.model.Description = this.steps.find(x => x.step_id === this.model.StepId).description;
        this.$forceUpdate();
    }

    validateStartDate(val) {
        this.model.StartDate = val;
        this.$forceUpdate();
    }

     validateEndDate(val) {
        this.model.EndDate = val;
        this.$forceUpdate();
    }
}
